import { render, staticRenderFns } from "./NaturalPersonCardList.vue?vue&type=template&id=2181f1c5&scoped=true&"
import script from "./NaturalPersonCardList.vue?vue&type=script&lang=js&"
export * from "./NaturalPersonCardList.vue?vue&type=script&lang=js&"
import style0 from "./NaturalPersonCardList.vue?vue&type=style&index=0&id=2181f1c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2181f1c5",
  null
  
)

export default component.exports